<script lang="ts">
  export let title: string;
  export let isOpen: boolean = false;

  const toggle = () => isOpen = !isOpen;
</script>

<div>
  <button class="flex gap-2" on:click={toggle}>
    <span class="action">{isOpen ? "-" : "+"}</span>
    <span class="title font-semibold">{title}</span>
  </button>
  <div class={isOpen ? "" : "hidden"}>
    <slot/>
  </div>
</div>

<style>
  button {
    color: var(--color-grayscale-90);
  }

  .action {
    font-size: 1.5rem;
    line-height: 1.25rem;
    width: 1rem;
  }
</style>
